var r = /* @__PURE__ */ ((I) => (I.ACTIVE = "ACTIVE", I.INACTIVE = "INACTIVE", I))(r || {});
export {
  r as LeadStatus
};
//# sourceMappingURL=lead.js.map
